import React, { useCallback, useMemo, useState } from "react";
import { TextField } from '@mui/material'
import { SxProps } from "@mui/material";
import { Theme } from "@mui/material";

interface DateTextFieldProps {
    label: string;
    value?: string;
    sx?: SxProps<Theme>;
    onChange: (value: string) => void;
}

class DateParser {
    applyMask(value: string): string {
        let newValue = value.replace(/\D/g, '');

        newValue = newValue.slice(0, 8);

        if (newValue.length > 2) {
            newValue = newValue.slice(0, 2) + '/' + newValue.slice(2);
        }
        if (newValue.length > 5) {
            newValue = newValue.slice(0, 5) + '/' + newValue.slice(5);
        }

        return newValue;
    }

    isValidDate(value: string): boolean {
        const [day, month, year] = value.split('/').map(Number);
        const date = new Date(year, month - 1, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day
        );
    }
}

const DateTextField: React.FC<DateTextFieldProps> = ({ label, value = "", sx, onChange }) => {
    const dateParser = useMemo(() => new DateParser(), []);
    const [fieldValue, setFieldValue] = useState<string>(dateParser.applyMask(value));
    const [error, setError] = useState<boolean>(false);

    const handleValueChange = useCallback((newValue: string) => {
        const maskedValue = dateParser.applyMask(newValue);
        setFieldValue(maskedValue);

        if (maskedValue.length === 10) {
            const isValid = dateParser.isValidDate(maskedValue);
            setError(!isValid);
            if (isValid) {
                onChange(maskedValue);
            }
        } else {
            setError(false);
        }
    }, [dateParser, onChange]);

    return (
        <TextField
            style={{marginTop: "8px", width: '100%'}}
            label={label}
            value={fieldValue}
            onChange={event => handleValueChange(event.target.value || "")}
            error={error}
            helperText={error ? "Data inválida" : ""}
            placeholder="dd/mm/yyyy"
            inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*"
            }}
        />
    );
};

export default DateTextField;